import { IMDSButtonProps, MDSButtonLoadingIndicator, MDSButtonSlotName } from "./button.types";
import { StyledButton, StyledSpinnerOverlay } from "./button.style";
import { getSlot, getUnslottedChildren } from "@/mds/utils/slots";
import classNames from "classnames";
import { forwardRef, Ref } from "react";
import { MDSIcon } from "@/mds/components/icon/icon/icon";
import { MDSIconKind } from "@/mds/components/icon/icon/icon.types";

export const MDSButton = forwardRef(
  (
    {
      children,
      isLoading,
      loadingIndicator = MDSButtonLoadingIndicator.Overlay,
      ...props
    }: IMDSButtonProps,
    ref: Ref<HTMLButtonElement>
  ) => {
    const { className, isDisabled, ...buttonProps } = props;
    const unslottedChildren = getUnslottedChildren(children);
    const leftIcon = getSlot(children, MDSButtonSlotName.LeftIcon);
    const rightIcon = getSlot(children, MDSButtonSlotName.RightIcon);
    const useIconPlacement = isLoading && loadingIndicator === MDSButtonLoadingIndicator.Icon;
    const showOverlay = isLoading && loadingIndicator === MDSButtonLoadingIndicator.Overlay;

    return (
      <StyledButton
        data-mds-name="button"
        {...buttonProps}
        className={classNames("mds-button", className)}
        isDisabled={isLoading || isDisabled}
        ref={ref}
      >
        {useIconPlacement ? (
          <MDSIcon slot={MDSButtonSlotName.LeftIcon} kind={MDSIconKind.Spinner} />
        ) : (
          leftIcon
        )}
        {unslottedChildren}
        {rightIcon}

        {showOverlay && (
          <StyledSpinnerOverlay>
            <MDSIcon kind={MDSIconKind.Spinner} />
          </StyledSpinnerOverlay>
        )}
      </StyledButton>
    );
  }
);
